import type { UseFormReturn } from 'react-hook-form';
import { SelectWithCreate } from '../../../components/ui/InlineCreate';
import { asRecord, str } from '../../../platform/api/utils';
import {
  type CreateForm,
  Field,
  inputCss,
  modalOverlay,
  modalStyle,
  primaryBtn,
  secondaryBtn,
} from './inventory-list.support';

export function InventoryCreateModal(props: {
  form: UseFormReturn<CreateForm>;
  categories: Record<string, unknown>[];
  locations: Record<string, unknown>[];
  createCategory: { isPending: boolean; mutateAsync: (name: string) => Promise<unknown> };
  createLocation: { isPending: boolean; mutateAsync: (name: string) => Promise<unknown> };
  createPending: boolean;
  onCancel: () => void;
  onCreate: () => void;
}) {
  const {
    form,
    categories,
    locations,
    createCategory,
    createLocation,
    createPending,
    onCancel,
    onCreate,
  } = props;

  return (
    <div
      style={modalOverlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div style={modalStyle}>
        <h3 style={{ margin: '0 0 1rem', fontSize: '1rem' }}>Novo item</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <Field label="Nome" error={form.formState.errors.name?.message}>
            <input {...form.register('name')} style={inputCss} />
          </Field>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
            <Field label="Unidade">
              <input {...form.register('unit')} style={inputCss} placeholder="un, kg, L, etc." />
            </Field>
            <Field label="Quantidade atual">
              <input
                {...form.register('currentQuantity')}
                style={inputCss}
                type="number"
                step="any"
              />
            </Field>
          </div>
          <Field label="Quantidade mínima">
            <input
              {...form.register('minimumQuantity')}
              style={inputCss}
              type="number"
              step="any"
              placeholder="Opcional"
            />
          </Field>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
            <SelectWithCreate
              label="Categoria"
              value={form.watch('categoryId') ?? ''}
              onChange={(id) => {
                form.setValue('categoryId', id);
              }}
              options={categories.map((c) => ({ id: str(c.id), name: str(c.name) }))}
              createLabel="+ Nova categoria"
              createPlaceholder="Ex.: Limpeza, Cozinha..."
              creating={createCategory.isPending}
              onCreate={async (name) => {
                const created = await createCategory.mutateAsync(name);
                return str(asRecord(created).id);
              }}
            />
            <SelectWithCreate
              label="Localização"
              value={form.watch('locationId') ?? ''}
              onChange={(id) => {
                form.setValue('locationId', id);
              }}
              options={locations.map((l) => ({ id: str(l.id), name: str(l.name) }))}
              createLabel="+ Nova localização"
              createPlaceholder="Ex.: Despensa, Sala..."
              creating={createLocation.isPending}
              onCreate={async (name) => {
                const created = await createLocation.mutateAsync(name);
                return str(asRecord(created).id);
              }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              gap: '0.5rem',
              justifyContent: 'flex-end',
              marginTop: '0.5rem',
            }}
          >
            <button type="button" onClick={onCancel} style={secondaryBtn}>
              Cancelar
            </button>
            <button type="button" onClick={onCreate} disabled={createPending} style={primaryBtn}>
              {createPending ? 'Criando...' : 'Criar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
